import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Notificacion } from '@/shared/domain/types';

const MAX_LOCAL = 100;

/** Bandeja local (alertas locales disparadas). La de la cuenta vive en el servidor. */
export interface NotificacionesLocalState {
  items: Notificacion[];
}

const slice = createSlice({
  name: 'notificacionesLocal',
  initialState: { items: [] } as NotificacionesLocalState,
  reducers: {
    pushNotificacionLocal(state, a: PayloadAction<Notificacion>) {
      state.items.unshift(a.payload);
      if (state.items.length > MAX_LOCAL) state.items.length = MAX_LOCAL;
    },
    markNotificacionLocalLeida(state, a: PayloadAction<string>) {
      const n = state.items.find((x) => x.id === a.payload);
      if (n) n.leida = true;
    },
    markTodasLocalesLeidas(state) {
      state.items.forEach((n) => {
        n.leida = true;
      });
    },
    removeNotificacionLocal(state, a: PayloadAction<string>) {
      state.items = state.items.filter((x) => x.id !== a.payload);
    },
    clearNotificacionesLocales(state) {
      state.items = [];
    },
  },
});

export const {
  pushNotificacionLocal,
  markNotificacionLocalLeida,
  markTodasLocalesLeidas,
  removeNotificacionLocal,
  clearNotificacionesLocales,
} = slice.actions;
export const notificacionesLocalReducer = slice.reducer;
